<template>
    <transition name="modal" appear>
        <div class="modal">
            <div class="modal-background"></div>
            <div class="modal-content">
                <button class="modal-close is-medium" type="button" aria-label="close" @click="close()" v-if="onClose"></button>
                <slot></slot>
            </div>
            <button class="modal-close outside is-medium" type="button" aria-label="close" @click="close()" v-if="onClose"></button>
        </div>
    </transition>
</template>

<script>
export default {
    name: "modal",
    props: [ "onClose" ],
    methods: {
        close() {
            this.onClose();
        },
        escapeKeyListener(e) {
            if(e.code === "Escape") {
                if(e.code === "Escape") {
                    this.close();
                }
            }
        }
    },
    mounted() {
        if(this.onClose) {
            document.addEventListener('keyup', this.escapeKeyListener);
        }
    },
    destroyed() {
        document.removeEventListener('keyup', this.escapeKeyListener);
    }
    
};
</script>

<style>
.modal:not(.loading-data) {
    display: flex !important;
    transition: all 150ms ease-in-out;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
}

.modal.loading-data {
    display: flex !important;
}

.modal-enter-to {
    transition: none !important;
}

.modal.loading-data {
    justify-content: start;
}

.modal.loading-data .modal-content {
    position: fixed;
    top: 40%;
}

.modal-background {
    background-color: rgba(10, 10, 10, 0.6) !important;
    height: 100vh;
}

.modal {
    justify-content: normal!important;
}

.modal-content {
    padding: 2rem;
    background-color: white !important;
    width: 75% !important;
    max-width: 1200px;
    border-radius: 8px;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    margin-top: 4rem!important;
    margin-bottom: 4rem!important;

    transition: all 200ms ease-in-out;
}

.modal.image .modal-content {
    padding: 0;
    background-color: transparent!important;
}

.modal.image .modal-content {
    overflow: visible;
}

.modal.image .modal-content img {
    display: block;
    width: auto;
    max-height: calc(100vh - 10rem);
    margin: 0 auto auto;
}

.modal-enter-active:not(.loading-data),
.modal-leave-to:not(.loading-data) {
    opacity: 0;
}

.modal-enter-active:not(.loading-data) .modal-content,
.modal-leave-to:not(.loading-data) .modal-content {
    /*transform: translateY(-3rem);*/
    transform: scale(0.8);
}

.modal-content .title {
    font-size: 1.3rem !important;
}

.modal-actions {
    text-align: right;
}

.modal-actions .button:not(:last-child) {
    margin-right: 0.5em;
}

.modal.small .modal-content {
    width: 600px !important;
}

.modal.smallest .modal-content {
    width: 400px !important;
}


@media screen and (max-width: 768px) {
    .modal.small .modal-content {
        width: 90% !important;
    }

    .modal.smallest .modal-content {
        width: 90% !important;
    }

    .modal:not(.small) .modal-content {
        width: 100% !important;
        border-radius: 0px!important;
        max-height: none!important;
        margin-top: 0rem!important;
        padding: 1.5rem;
        margin-bottom: 0rem!important;
    }

    .modal-enter-active:not(.loading-data),
    .modal-leave-to:not(.loading-data) {
        opacity: 0;
    }

    .modal-enter-active:not(.loading-data):not(.small) .modal-content,
    .modal-leave-to:not(.loading-data):not(.small) .modal-content {
        transform: translateY(100vh);
    }

    .modal:not(.small) .modal-background {
        background-color: white!important;
    }

    .modal-close:not(.small) {
        position: absolute;
    }

    .modal-close.outside {
        display: none;
    }

    .modal:not(.small) .modal-close::after {
        background-color: #aaaaaa;
    }

    .modal:not(.small) .modal-close::before {
        background-color: #aaaaaa;
    }

    .modal:not(.small) .modal-close:hover::after {
        background-color: white;
    }

    .modal:not(.small) .modal-close:hover::before {
        background-color: white;
    }
}
</style>